import { render, staticRenderFns } from "./perfil-do-investidor.vue?vue&type=template&id=77a5d10e&"
import script from "./perfil-do-investidor.vue?vue&type=script&lang=ts&"
export * from "./perfil-do-investidor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports